<template>
  <section class="app-main">
    <!-- <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition> -->

    <keep-alive>
      <!-- <transition v-if="$route.meta.keepAlive" name="fade-transform" mode="out-in"> -->
      <router-view v-if="$route.meta.keepAlive && isRouterReload" />
      <!-- </transition> -->
    </keep-alive>

    <transition v-if="!$route.meta.keepAlive" name="fade-transform" mode="out-in">
      <router-view v-if="isRouterReload" />
    </transition>

  </section>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  name: 'app-main',
  provide: {
    pageReload: this.reload
  },
  data() {
    return {
      isRouterReload: true
    }
  },
  computed: {
    // cachedViews() {
    //   return this.$store.state.tagsView.cachedViews
    // },
    // key() {
    //   return this.$route.path
    // }
  },
  created() {
    eventBus.$off('pageReload')
    eventBus.$on('pageReload', this.reload)
  },
  methods: {
    // 用于表单重置页面
    reload() {
      this.isRouterReload = false
      this.$nextTick(() => {
        this.isRouterReload = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  height: calc(100vh - 57px);
  width: 100%;
  position: relative;
  overflow: auto;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    // padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue